import React from "react";
import {useNavigate} from "react-router-dom";
import {Constants} from "./Constants";

export let NotFoundPage = function () {
    let navigate = useNavigate();

    return (
        <div>
            <h1>Page Not Found</h1>
            <p>The page you are looking for does not match a known route.</p>
            <div
                className="not-found-page-dashboard-link"
                onClick={() => navigate(`/${Constants.routes.dispatch.pathSegment}`)}
            >
                Return to Dispatch
            </div>
        </div>
    );
};
